import {connect} from 'react-redux'
import DatePickerRange from './datePickerRange'
import {getUser} from 'selectors/auth'

const mapStateToProps = (state) => ({
  invoiceFinancialYearStart: getUser(state).settings.invoiceFinancialYearStart,
})

export default connect(mapStateToProps)(DatePickerRange)



